import React from "react";
import "./AverageTime.scss";

import { prettify } from "../../../utils/formatDate";
import { secondsToMinutes } from "../../../utils/secondsToMinutes";

const AverageTimeCard = ({ data }: { data: any }) => {
  console.log(data, "average time data");

  return (
    <div>
      {/* <h2 className="card-title">Average time to complete stories</h2> */}

      <div className="top-row">
        {/* Highest */}
        <div className="stat-block">
          <div className="label highest">HIGHEST</div>
          <div className="value-box">
            <span className="story">{prettify(data?.highest?.storyName)}</span>
            <span className="dividr" />
            <span className="time">
              {secondsToMinutes(data?.highest?.value)}
            </span>
          </div>
        </div>

        {/* Lowest */}
        <div className="stat-block">
          <div className="label lowest">LOWEST</div>
          <div className="value-box">
            <span className="story">{prettify(data?.lowest?.storyName)}</span>
            <span className="dividr" />
            <span className="time">
              {secondsToMinutes(data?.lowest?.value)}
            </span>
          </div>
        </div>
      </div>

      {/* Median */}
      <div className="stat-block median-block">
        <div className="label median">MEDIAN</div>
        <div className="values-box">
          <span className="story">
            {prettify(data?.median?.storyName || "Median")}
          </span>
          <span className="dividerss" />
          <span className="time">{secondsToMinutes(data?.median)}</span>
        </div>
      </div>
    </div>
  );
};

export default AverageTimeCard;
